export default __webpack_public_path__ + "static/media/ConductivitySensors.7769b87b.jpg";